var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-ignore
import { Component } from 'lib';
import { withLocales } from 'react-localized';
// eslint-disable-next-line
var CompDecoratedClass = /** @class */ (function (_super) {
    __extends(CompDecoratedClass, _super);
    function CompDecoratedClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompDecoratedClass.prototype.render = function () {
        // @ts-ignore
        var _a = this.props, pgettext = _a.pgettext, npgettext = _a.npgettext, formats = _a.formats, formatDate = _a.formatDate;
        return (_jsxs(_Fragment, { children: [_jsx("p", { children: formatDate(new Date(), formats.date) }), _jsx("p", { children: pgettext('Context', 'Text with context') }), _jsxs("p", { children: ["2 ", npgettext('Context', 'table', 'tables', 2)] })] }));
    };
    return CompDecoratedClass;
}(Component));
var CompDecoratedClassWithLocales = withLocales()(CompDecoratedClass);
export default CompDecoratedClassWithLocales;
